export const formatOverhangSequence = (str: string) => {
  const matches = str.match(/-r([A-Z])/g)
  if (matches && matches.length) {
    return matches.map((match) => match.charAt(2)).join('')
  } else {
    return str
  }
}
